angular.module("admin").factory("FaresService", ["$rootScope", "$http", "ENV", function ($rootScope, $http, ENV) {

	/**
	 * API
	 */
	return {
		importUserProfiles: importUserProfiles,
		importFaresCSV: importFaresCSV,
		importFaresNetex: importFaresNetex,
		deleteDataFares: deleteDataFares,
		deleteProviderFares: deleteProviderFares,
		hasData:hasData
	};

	function importUserProfiles(user, newImportUserProfiles, referential) {
		return $http.post(ENV.FARES_BASE_URL + "fares-referential/fares/import-user-profiles", newImportUserProfiles.file, {
			transformRequest: angular.identity,
			headers: {
				"accept": "*/*",
				"Content-Type": "text/csv",
				"user": user,
				"fileName": newImportUserProfiles.file.name,
				"referential": referential ? referential.toUpperCase() : referential
			}
		});
	}

	function importFaresCSV(user, newImportFares, referential) {
		return $http.post(ENV.FARES_BASE_URL + "fares-referential/fares/import/csv", newImportFares.file, {
			transformRequest: angular.identity,
			headers: {
				"accept": "*/*",
				"Content-Type": "text/csv",
				"user": user,
				"fileName": newImportFares.file.name,
				"referential": referential
			}
		});
	}

	function hasData(providerId){
		return $http.get(ENV.FARES_BASE_URL + "fares-referential/fares/has-data/" + providerId, {
			transformRequest: angular.identity
		});
	}






	function importFaresNetex(user, fileName, newImportFares, referential) {
		let formData = new FormData();
		formData.append('file', newImportFares.file);

		return $http.post(ENV.FARES_BASE_URL + "fares-referential/fares/import/netex", formData, {
			headers: {
				'Content-Type': undefined,
				'user': user,
				'fileName': fileName,
				'referential': referential
			}
		}).then(function(response) {
			console.log("Fichier envoyé avec succès");
		}).catch(function(error) {
			console.error("Erreur lors de l'envoi du fichier :", error);
		});
	}

	function deleteDataFares(user) {
		return $http.delete(ENV.FARES_BASE_URL + "fares-referential/fares/delete-all-data", {
			transformRequest: angular.identity,
			headers: {
				"user": user,
			}
		});
	}

	function deleteProviderFares(provider, user){
		return $http.delete(ENV.FARES_BASE_URL + "fares-referential/fares/delete-for-provider", {
			transformRequest: angular.identity,
			headers: {
				"user": user,
				"provider": provider
			}
		});
	}

}]);